/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Blocked_RegimeInputs */



/**
* | output |
* | --- |
* | "This partner's tax regime is not supported yet, so payouts stay on hold." |
*
* @param {Partner_Admin_Commission_Blocked_RegimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_blocked_regime = /** @type {((inputs?: Partner_Admin_Commission_Blocked_RegimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Blocked_RegimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Steuerregime dieses Partners wird noch nicht unterstützt, Auszahlungen bleiben ausgesetzt.")
	return /** @type {LocalizedString} */ ("This partner's tax regime is not supported yet, so payouts stay on hold.")
});